module.exports = __webpack_public_path__ + "static/media/good-review3.079c9d47.png";